import { useContext,useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
//import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
//import { interfaces } from "service/interfaces"
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import Asientos from 'Components/UI/Organisms/Sales/Clients/Edit/Asientos'
import CtaCteClient from 'Components/UI/Organisms/Sales/Clients/Edit/CTACTEClient'
import HomeContent from 'Components/UI/Organisms/Sales/Clients/Edit/Home'

const EditClientInfo = (props) => {
  const { open, handleclose, data, setRender, render, fromOrders } = props
  //const createDismissableSnackbar = useCustomSnackbar()

  const { state, setClose } = SetState()
  const [edit] = useContext(EditContext)

  const [dataInfo, setDataInfo] = useState({
    ...data,
    data: {
      ...data.infoClient,
    },
  })
  const onDataChange = (newData) => {
    setDataInfo((prevDataInfo) => ({
      ...prevDataInfo,
      details: newData,
    }))
  }

  const horizontalTabs = [
    {
      id: 0,
      title: 'Inicio',
      color: 'primary',
    },
    {
      id: 1,
      title: 'CTA CTE Cliente',
      color: 'primary',
    },
    {
      id: 2,
      title: 'Archivos',
      color: 'primary',
    },
    {
      id: 3,
      title: 'Asientos',
      color: 'primary',
    },
    {
      id: 4,
      title: 'Historial',
      color: 'primary',
    },
  ]

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <HomeContent
            data={dataInfo}
            setData={setDataInfo}
            edit={edit}
            onDataChange={onDataChange}
            setRender={setRender}
            render={render}
            fromOrders={fromOrders}
          />
        )
      case 1:
        return (
          <CtaCteClient
            data={dataInfo}
            setData={setDataInfo}
            edit={edit}
            onDataChange={onDataChange}
            setRender={setRender}
            render={render}
            fromOrders={fromOrders}
          />
        )
      case 2:
        return ''
      case 3:
        return <Asientos data={dataInfo} onDataChange={onDataChange} edit={edit} />
      case 4:
        return <ComplexDialogHistory history={data.history} />
      default:
        break
    }
  }

  //const date = dataInfo.info.creacion.split('T')[0]

  return (
    <>
      <ComplexDialog
        open={open}
        onClose={handleclose}
        tabs={horizontalTabs}
        title={`${dataInfo.infoClient.nombre} ID ${dataInfo.infoClient.id}`}
        height="600px"
        subtitle={<div>{`Creado el FECHA por USUARIO`}</div>}
        children={renderTabs}
      />

      {state.suspense && (
        <DialogComponent
          open={state.open}
          handleclose={state.loading ? null : setClose}
          widthLarge={500}
          title="¿Desea eliminar el siguiente proveedor?"
          subtitle="¡Esta acción es irreversible!"
          disableChildHeight
          disableBackdropClick
          disableEscapeKeyDown
        />
      )}
    </>
  )
}

export default EditClientInfo
